"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateCatalog = void 0;
const react_1 = require("react");
const client_utils_1 = require("../../client.utils");
const ticket_1 = require("../../ticket");
const upload_catalog_hook_1 = require("../upload-catalog.hook");
const store_1 = require("../../../../store");
const useUpdateCatalog = ({ catalog, }) => {
    const selectedProjectId = (0, store_1.useSelectedProjectId)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const catalogTags = (0, store_1.useSelectedCatalogTags)();
    const { createTicketSequenceForCatalog } = (0, ticket_1.useCreateTicketSequenceForCatalog)();
    const { uploadCatalog } = (0, upload_catalog_hook_1.useUploadCatalog)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const updateCatalog = (0, react_1.useCallback)((fileToUpload) => __awaiter(void 0, void 0, void 0, function* () {
        if (!catalog) {
            return;
        }
        setError(null);
        setIsLoading(true);
        const { file, id: fileName } = fileToUpload;
        try {
            const { data: uploadCatalogResponseData } = yield uploadCatalog({ variables: { name: fileName, file } });
            const { read: readUrl } = uploadCatalogResponseData.upload.urls;
            const createTicketSequenceForCatalogResponse = yield createTicketSequenceForCatalog({
                catalogId: selectedCatalogId,
                tags: catalogTags,
                tickets: ticket_1.TICKETS_FOR_REPLACE_CATALOG,
                options: {
                    readUrl,
                },
                variables: { projectId: selectedProjectId },
            });
            (0, client_utils_1.genericGraphQLErrorsHandler)(createTicketSequenceForCatalogResponse);
        }
        catch (e) {
            setError(e);
            throw new Error(e.message);
        }
        finally {
            setIsLoading(false);
        }
    }), [catalog, createTicketSequenceForCatalog, selectedCatalogId, selectedProjectId, catalogTags, uploadCatalog]);
    return {
        updateCatalog,
        loading: isLoading,
        error,
    };
};
exports.useUpdateCatalog = useUpdateCatalog;
